import { render } from "./CaptchaVerifier.vue?vue&type=template&id=a5740506&lang=pug"
import script from "./CaptchaVerifier.vue?vue&type=script&lang=js"
export * from "./CaptchaVerifier.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__